import { css } from '@emotion/css';

export const spinnerContainerCss = css`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;
